import classNames from 'classnames';
import { forwardRef } from 'react';
const rulesContainerCss = "r6rqvqu";
export const RulesContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rulesContainerCss, props.className)} />;
});
const ruleContainerCss = "r1u8mzts";
export const RuleContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(ruleContainerCss, props.className)} />;
});
const yearContainerCss = "y1at2xn5";
export const YearContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(yearContainerCss, props.className)} />;
});
const wrapperCss = "w7uf6qw";
export const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});

// Export CSS classes for external usage
export { rulesContainerCss, ruleContainerCss, yearContainerCss, wrapperCss };

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");